// Converts a string validated with the ccEmail validator into an array of unique emails
export const ccEmailArray = (ccEmail: string): string[] => {
  const arr = ccEmail
    .split(/\s|,/)
    .map((s) => s.trim())
    .filter((s) => s !== '')

  return [...new Set(arr)]
}
